
import { defineComponent, onMounted, ref } from 'vue';
import { CheckOutlined } from '@ant-design/icons-vue';
import G6 from '@antv/g6';
import { moveItemToCenter, registerNode } from './node';

export default defineComponent({
  name: 'ProjectProcess',
  components: {
    CheckOutlined
  },
  props: ['pdata'],
  setup(props, ctx) {
    onMounted(() => {
      const interval = setInterval(() => {
        if (props.pdata.length) {
          clearInterval(interval);
          const nodes = props.pdata;
          let notActiveNodeId;
          let lastNodeId;
          nodes.sort((a, b) => a.sort - b.sort);
          nodes.forEach((i, index) => {
            i.id = (index + 1).toString();
            if (!notActiveNodeId && !i.dealState) {
              notActiveNodeId = i.id;
            }
            if (index === nodes.length - 1) {
              lastNodeId = i.id;
            }
          });
          const sameSort: any[] = [];
          const edges: any[] = [];
          for (let i = 0; i < nodes.length - 1; i++) {
            const item = nodes[i];
            const nextItem = nodes[i + 1];
            const nextNextIitem = nodes[i + 2];
            let sourceId = item.id;
            let targetId;

            if (item.sort === nextItem.sort) {
              sameSort.push(item.sort);
              if (i === nodes.length - 2) {
                break;
              }
              targetId = nextNextIitem.id;
            } else {
              targetId = nextItem.id;
            }

            const style = {
              stroke: item.dealState ? '#035DFF' : '#C1C9D2'
            };

            edges.push({ source: sourceId, target: targetId, style });
            if (nextItem.sort === nextNextIitem?.sort) {
              edges.push({ source: sourceId, target: nextNextIitem.id, style });
            }
          }

          const data = {
            nodes,
            edges
          };

          const container = document.querySelector('#project-progress')! as HTMLDivElement;
          const width = container.offsetWidth;
          const height = container.offsetHeight || 500;

          registerNode(G6);

          const minimap = new G6.Minimap({
            container,
            size: [100, 100],
            className: 'minimap',
            type: 'delegate'
          });

          const graph = new G6.Graph({
            container,
            renderer: 'svg',
            width,
            height,
            minZoom: 0,
            layout: {
              type: 'dagre',
              rankdir: 'LR',
              nodesep: 47,
              ranksepFunc(cfg) {
                if (sameSort.includes(cfg.sort)) {
                  return 120;
                }
                return 150;
              },
              controlPoints: true
            },
            defaultNode: {
              type: 'CUSTOM_NODE',
              anchorPoints: [
                [1, 0.25],
                [0, 0.25]
              ]
            },
            defaultEdge: {
              type: 'cubic-horizontal',
              style: {
                endArrow: true,
                lineWidth: 1
              }
            },
            modes: {
              default: ['drag-canvas']
            },
            plugins: [minimap]
          });

          graph.data(data);
          graph.render();

          setTimeout(() => {
            if (notActiveNodeId > 2) {
              const item = graph.findById(notActiveNodeId);
              moveItemToCenter(item, graph);
            } else if (!notActiveNodeId) {
              const item = graph.findById(lastNodeId);
              moveItemToCenter(item, graph);
            } else {
              const item = graph.findById('1');
              moveItemToCenter(item, graph);
            }
          }, 0);

          if (typeof window !== 'undefined')
            window.onresize = () => {
              if (!graph || graph.get('destroyed')) return;
              if (!container || !container.offsetWidth || !container.offsetHeight) return;
              graph.changeSize(container.offsetWidth, container.offsetHeight);
            };
        }
      }, 300);
    });

    return {};
  }
});
